var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgMetaWalletCardMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 218,
    viewBox: "0 0 224 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.258 161.669C59.0117 169.583 63.043 175.001 66.8217 177.808C71.7744 181.483 77.3761 181.825 82.3588 180.091C88.7879 177.855 94.1605 174.359 100.542 156.173C105.649 141.598 110.777 121.856 114.479 109.302L120.746 88.0396C125.104 73.2743 130.33 56.7249 138.477 43.9107C145.12 33.4508 153.612 25.966 163.578 22.4988C180.299 16.6814 199.296 19.9407 217.231 32.2127C236.866 45.6556 251.27 66.1806 259.449 89.689C264.312 103.665 264.85 114.99 262.514 124.897C260.261 134.477 253.274 145.695 236.929 151.382L229.147 129.013C243.142 124.144 242.564 111.249 237.913 97.8803C231.285 78.8305 219.037 59.3859 203.013 48.0246C191.642 39.9658 179.457 36.8652 168.556 40.6581C156.768 44.7594 150.096 56.132 144.447 74.2419C141.44 83.8628 138.866 95.2147 135.997 108.006L132.835 122.083C126.485 150.383 124.665 156.951 120.495 168.211C113.165 187.928 104.376 197.499 90.1472 202.45C73.2677 208.323 60.2819 205.398 50.1859 197.688C41.9412 191.42 35.5674 181.64 31.3233 169.441L56.258 161.669Z",
    fill: "#0081FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8029 99.5488C34.5988 79.787 47.0594 63.0453 65.7698 56.5356C76.6048 52.7659 88.3876 51.9363 102.534 56.364C118.014 61.2048 136.348 71.6604 161.324 90.7298L170.285 97.5747C191.905 114.082 203.79 122.302 210.315 125.865C218.7 130.433 223.639 130.945 229.157 129.025C243.152 124.156 242.574 111.261 237.923 97.8929L259.451 89.7045C264.314 103.68 264.852 115.006 262.516 124.912C260.263 134.492 253.275 145.711 236.931 151.397C226.773 154.931 217.072 156.059 204.155 150.99C194.227 147.104 181.236 138.588 170.717 130.522L139.442 106.577C123.75 94.555 110.285 86.2118 102.994 82.8474C95.1565 79.2306 85.2455 75.0153 73.2066 79.2039C63.4669 82.5925 57.3576 91.6748 53.7412 103.585L28.8029 99.5488Z",
    fill: "url(#paint0_linear_8806_69561)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1964 79.1913C63.4566 82.58 57.3473 91.6623 53.7309 103.573C48.6106 120.4 49.5774 142.467 56.258 161.669C59.0117 169.583 63.043 175.001 66.8217 177.808L50.1801 197.699C41.9412 191.42 35.5674 181.64 31.3233 169.441C23.6094 147.27 22.2645 121.826 28.7954 99.5439C34.5912 79.7821 47.0519 63.0404 65.7622 56.5307L73.1964 79.1913Z",
    fill: "url(#paint1_linear_8806_69561)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8806_69561",
    x1: 72.2004,
    y1: 127.494,
    x2: 232.306,
    y2: 81.5794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0073EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8806_69561",
    x1: 67.7537,
    y1: 168.208,
    x2: 49.4394,
    y2: 115.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaWalletCardMobile);
export default __webpack_public_path__ + "static/media/meta-wallet-card-mobile.87ae280002d90d2f494f78e2ef0251d6.svg";
export { ForwardRef as ReactComponent };